import { LocalStorageHelper } from "@travellocal/utils/localStorageHelper";
import { SystemApiClient } from "./apiClientBase";

import { isBrowser } from "../../../core/detection";
let fetchAuthToken;
if (isBrowser()) {
  fetchAuthToken = () => LocalStorageHelper.getItem("authtoken");
}

export const api = new SystemApiClient(fetchAuthToken);
